import { computed, Injectable, signal } from '@angular/core';

export type Theme = 'adesso' | 'adesso-dark';

const STORAGE_KEY = 'am-one-theme';
const LIGHT_THEME: Theme = 'adesso';
const DARK_THEME: Theme = 'adesso-dark';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private theme = signal<Theme>(LIGHT_THEME);
  isDark = computed(() => this.theme() === DARK_THEME);

  loadTheme(): void {
    const stored = localStorage.getItem(STORAGE_KEY) as Theme | null;
    if (stored) {
      this.applyTheme(stored);
    } else {
      if (window.matchMedia) {
        if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
          this.applyTheme(DARK_THEME);
        } else {
          this.applyTheme(LIGHT_THEME);
        }
      } else {
        this.applyTheme(LIGHT_THEME);
      }
    }
  }

  toggle(): void {
    this.applyTheme(this.theme() === LIGHT_THEME ? DARK_THEME : LIGHT_THEME);
  }

  applyTheme(theme: Theme): void {
    if (this.setDataThemeOnHTML(theme)) {
      this.saveToStorage(theme);
      this.theme.set(theme);
    }
  }

  private saveToStorage(theme: Theme): void {
    localStorage.setItem(STORAGE_KEY, theme);
  }

  private setDataThemeOnHTML(theme: Theme): boolean {
    const html = document.querySelector('html');
    if (html) {
      html.setAttribute('data-theme', theme);
      return true;
    }
    return false;
  }
}
